export function hasServerCredentials(value: unknown): boolean {
  const device = value as { id?: unknown; activationDisplayId?: unknown; activationPassword?: unknown; status?: unknown } | null;
  return Boolean(device && typeof device.id === 'string' && device.id.trim()
    && typeof device.activationDisplayId === 'string' && /^[A-Z0-9]{12}$/.test(device.activationDisplayId.replace(/[.\s-]/g, ''))
    && typeof device.activationPassword === 'string' && device.activationPassword.length >= 6
    && (device.status === 'active' || device.status === 'blocked'));
}

export function temporaryBootstrapFailure(status: number): boolean {
  return status === 0 || status === 429 || status >= 500;
}
